// AUTO-GENERATED by build_flavor_ratio_model.py  —  regenerate with:
//   python3 build_flavor_ratio_model.py
//
// Flat, authoritative flavor-ratio lookup for every strain in every tree.
// Keys are strain IDs (slugs).  Each entry records:
//   name    – display name
//   source  – where the data came from:
//               "storage_system"   → real vote data from storage_system/data/
//               "parent_blend"     → weighted average of parent strain proportions
//               "embedded"         → pulled from strainTree.json embedded flavors
//   flavors – array of { name, votes, proportion } sorted by proportion desc
//             Only salient flavors (votes > 0) are included.
//
// The FlavorTree component uses this as the primary lookup so every node's
// psychedelic color swirl reflects the real flavor distribution.
//
// Usage:
//   import { getFlavorRatios } from './strainFlavorRatios';
//   const flavors = getFlavorRatios(strain.id);

export const strainFlavorRatios = {

  // ─── MAX AC TREE ──────────────────────────────────────────────────────────

  // No storage_system file for Max AC; ratios computed as 50/50 blend of
  // Animal Cookies and MAC 1 parent proportions, then top-6 renormalised.
  "max_ac": {
    name:   "Max AC",
    source: "parent_blend",
    flavors: [
      { name:         "Earthy", votes:  61, proportion: 0.3034825871 },
      { name:         "Sweet", votes:  50, proportion: 0.2487562189 },
      { name:        "Citrus", votes:  32, proportion: 0.1592039801 },
      { name:       "Pungent", votes:  22, proportion: 0.1094527363 },
      { name:        "Butter", votes:  19, proportion: 0.0945273632 },
      { name:        "Diesel", votes:  17, proportion: 0.0845771144 },
    ]
  },

  "animal-cookies": {
    name:   "Animal Cookies",
    source: "storage_system",
    flavors: [
      { name:         "Earthy", votes: 211, proportion: 0.2874659401 },
      { name:         "Sweet", votes: 204, proportion: 0.2779291553 },
      { name:       "Pungent", votes: 133, proportion: 0.1811989101 },
      { name:          "Pine", votes:  68, proportion: 0.0926430518 },
      { name:         "Woody", votes:  60, proportion: 0.0817438692 },
      { name:       "Flowery", votes:  58, proportion: 0.0790190736 },
    ]
  },

  "mac-1": {
    name:   "MAC 1",
    source: "storage_system",
    flavors: [
      { name:        "Citrus", votes: 102, proportion: 0.2649350649 },
      { name:         "Earthy", votes:  82, proportion: 0.2129870130 },
      { name:        "Butter", votes:  59, proportion: 0.1532467532 },
      { name:        "Diesel", votes:  53, proportion: 0.1376623377 },
      { name:         "Sweet", votes:  52, proportion: 0.1350649351 },
      { name:         "Lemon", votes:  37, proportion: 0.0961038961 },
    ]
  },

  "gsc": {
    name:   "GSC",
    source: "storage_system",
    flavors: [
      { name:         "Sweet", votes: 1337, proportion: 0.3126022913 },
      { name:         "Earthy", votes: 1170, proportion: 0.2735562310 },
      { name:       "Pungent", votes:  650, proportion: 0.1519756839 },
      { name:          "Mint", votes:  378, proportion: 0.0883797054 },
      { name:       "Flowery", votes:  375, proportion: 0.0876782792 },
      { name:         "Woody", votes:  367, proportion: 0.0858078092 },
    ]
  },

  "fire-og": {
    name:   "Fire OG",
    source: "storage_system",
    flavors: [
      { name:         "Earthy", votes: 191, proportion: 0.2436224490 },
      { name:         "Lemon", votes: 162, proportion: 0.2066326531 },
      { name:       "Pungent", votes: 115, proportion: 0.1466836735 },
      { name:          "Pine", votes: 112, proportion: 0.1428571429 },
      { name:        "Citrus", votes: 111, proportion: 0.1415816327 },
      { name:         "Woody", votes:  93, proportion: 0.1186224490 },
    ]
  },

  "og-kush": {
    name:   "OG Kush",
    source: "storage_system",
    flavors: [
      { name:         "Earthy", votes: 1085, proportion: 0.3161421911 },
      { name:          "Pine", votes:  710, proportion: 0.2068764569 },
      { name:         "Woody", votes:  664, proportion: 0.1934731935 },
      { name:       "Pungent", votes:  433, proportion: 0.1261655012 },
      { name:         "Sweet", votes:  290, proportion: 0.0844988345 },
      { name:         "Skunk", votes:  250, proportion: 0.0728438228 },
    ]
  },

  "f1-durb": {
    name:   "F1 Durban",
    source: "storage_system",
    flavors: [
      { name:         "Berry", votes:   2, proportion: 0.2500000000 },
      { name:        "Diesel", votes:   2, proportion: 0.2500000000 },
      { name:        "Cheese", votes:   1, proportion: 0.1250000000 },
      { name:         "Earthy", votes:   1, proportion: 0.1250000000 },
      { name:       "Flowery", votes:   1, proportion: 0.1250000000 },
    ]
  },

  "sfv-og-kush": {
    name:   "SFV OG Kush",
    source: "storage_system",
    flavors: [
      { name:         "Earthy", votes:  50, proportion: 0.2702702703 },
      { name:         "Lemon", votes:  41, proportion: 0.2216216216 },
      { name:          "Pine", votes:  33, proportion: 0.1783783784 },
      { name:         "Sweet", votes:  23, proportion: 0.1243243243 },
      { name:        "Citrus", votes:  22, proportion: 0.1189189189 },
      { name:         "Woody", votes:  16, proportion: 0.0864864865 },
    ]
  },

  "sfv-og": {
    name:   "SFV OG",
    source: "storage_system",
    flavors: [
      { name:         "Earthy", votes: 182, proportion: 0.2676470588 },
      { name:          "Pine", votes: 163, proportion: 0.2397058824 },
      { name:         "Lemon", votes:  94, proportion: 0.1382352941 },
      { name:       "Pungent", votes:  92, proportion: 0.1352941176 },
      { name:         "Woody", votes:  76, proportion: 0.1117647059 },
      { name:        "Citrus", votes:  73, proportion: 0.1073529412 },
    ]
  },

  "alien-cookies": {
    name:   "Alien Cookies",
    source: "storage_system",
    flavors: [
      { name:         "Earthy", votes:  20, proportion: 0.2898550725 },
      { name:         "Sweet", votes:  14, proportion: 0.2028985507 },
      { name:       "Vanilla", votes:  14, proportion: 0.2028985507 },
      { name:       "Pungent", votes:   8, proportion: 0.1159420290 },
      { name:        "Citrus", votes:   6, proportion: 0.0869565217 },
    ]
  },

  // Note: "alien-dawg" is how the id appears in strainTree.json for "Aliendawg"
  "alien-dawg": {
    name:   "Aliendawg",
    source: "storage_system",
    flavors: [
      { name:         "Earthy", votes:  68, proportion: 0.3076923077 },
      { name:         "Woody", votes:  38, proportion: 0.1719457014 },
      { name:       "Pungent", votes:  36, proportion: 0.1628959276 },
      { name:         "Sweet", votes:  29, proportion: 0.1312217195 },
      { name:          "Pine", votes:  26, proportion: 0.1176470588 },
      { name:  "Spicy/Herbal", votes:  24, proportion: 0.1085972851 },
    ]
  },

  // ─── MIMOSA TREE ──────────────────────────────────────────────────────────

  "mimosa": {
    name:   "Mimosa",
    source: "storage_system",
    flavors: [
      { name:        "Citrus", votes: 360, proportion: 0.3625377644 },
      { name:        "Orange", votes: 200, proportion: 0.2014098691 },
      { name:         "Sweet", votes: 148, proportion: 0.1490433031 },
      { name:      "Tropical", votes: 109, proportion: 0.1097683787 },
      { name:         "Earthy", votes:  90, proportion: 0.0906344411 },
      { name:         "Lemon", votes:  86, proportion: 0.0866062437 },
    ]
  },

  "clementine": {
    name:   "Clementine",
    source: "storage_system",
    flavors: [
      { name:        "Citrus", votes: 232, proportion: 0.3636363636 },
      { name:        "Orange", votes: 152, proportion: 0.2382445141 },
      { name:         "Sweet", votes:  88, proportion: 0.1379310345 },
      { name:         "Lemon", votes:  80, proportion: 0.1253918495 },
      { name:         "Earthy", votes:  47, proportion: 0.0736677116 },
      { name:       "Pungent", votes:  39, proportion: 0.0611285266 },
    ]
  },

  "tangie": {
    name:   "Tangie",
    source: "storage_system",
    flavors: [
      { name:        "Citrus", votes: 532, proportion: 0.3577673167 },
      { name:        "Orange", votes: 441, proportion: 0.2965702757 },
      { name:         "Sweet", votes: 235, proportion: 0.1580363147 },
      { name:      "Tropical", votes: 114, proportion: 0.0766644250 },
      { name:       "Pungent", votes:  88, proportion: 0.0591795562 },
      { name:         "Earthy", votes:  77, proportion: 0.0517821116 },
    ]
  },

  "california-orange": {
    name:   "California Orange",
    source: "storage_system",
    flavors: [
      { name:        "Orange", votes: 124, proportion: 0.3502824859 },
      { name:        "Citrus", votes: 111, proportion: 0.3135593220 },
      { name:         "Sweet", votes:  62, proportion: 0.1751412429 },
      { name:         "Earthy", votes:  27, proportion: 0.0762711864 },
      { name:      "Tropical", votes:  16, proportion: 0.0451977401 },
      { name:         "Lemon", votes:  14, proportion: 0.0395480226 },
    ]
  },

  "skunk-1": {
    name:   "Skunk-1",
    source: "storage_system",
    flavors: [
      { name:         "Skunk", votes: 156, proportion: 0.3636363636 },
      { name:         "Earthy", votes:  91, proportion: 0.2121212121 },
      { name:       "Pungent", votes:  69, proportion: 0.1608391608 },
      { name:         "Sweet", votes:  56, proportion: 0.1305361305 },
      { name:         "Woody", votes:  29, proportion: 0.0675990676 },
      { name:       "Flowery", votes:  28, proportion: 0.0652680653 },
    ]
  },

  "lemon-skunk": {
    name:   "Lemon Skunk",
    source: "storage_system",
    flavors: [
      { name:         "Lemon", votes: 454, proportion: 0.3511214230 },
      { name:         "Skunk", votes: 280, proportion: 0.2165506574 },
      { name:        "Citrus", votes: 262, proportion: 0.2026295437 },
      { name:       "Pungent", votes: 106, proportion: 0.0819798917 },
      { name:         "Sweet", votes: 102, proportion: 0.0788863109 },
      { name:         "Earthy", votes:  89, proportion: 0.0688321732 },
    ]
  },

  "purple-punch": {
    name:   "Purple Punch",
    source: "storage_system",
    flavors: [
      { name:         "Grape", votes: 488, proportion: 0.2845481050 },
      { name:         "Berry", votes: 385, proportion: 0.2244897959 },
      { name:         "Sweet", votes: 339, proportion: 0.1976676385 },
      { name:     "Blueberry", votes: 198, proportion: 0.1154518950 },
      { name:         "Earthy", votes: 182, proportion: 0.1061224490 },
      { name:       "Flowery", votes: 123, proportion: 0.0717201166 },
    ]
  },

  "larry-og": {
    name:   "Larry OG",
    source: "storage_system",
    flavors: [
      { name:         "Lemon", votes: 163, proportion: 0.2440119760 },
      { name:          "Pine", votes: 151, proportion: 0.2260479042 },
      { name:         "Earthy", votes: 137, proportion: 0.2050898204 },
      { name:        "Citrus", votes:  94, proportion: 0.1407185629 },
      { name:       "Pungent", votes:  63, proportion: 0.0943113772 },
      { name:         "Sweet", votes:  60, proportion: 0.0898203593 },
    ]
  },

  "granddaddy-purple": {
    name:   "Granddaddy Purple",
    source: "storage_system",
    flavors: [
      { name:         "Grape", votes: 1078, proportion: 0.2738125476 },
      { name:         "Berry", votes:  942, proportion: 0.2392684785 },
      { name:         "Sweet", votes:  823, proportion: 0.2090424181 },
      { name:         "Earthy", votes:  508, proportion: 0.1290322581 },
      { name:       "Pungent", votes:  309, proportion: 0.0784861570 },
      { name:       "Flowery", votes:  277, proportion: 0.0703581407 },
    ]
  },

  "big-bud": {
    name:   "Big Bud",
    source: "storage_system",
    flavors: [
      { name:         "Earthy", votes:  63, proportion: 0.3073170732 },
      { name:         "Woody", votes:  40, proportion: 0.1951219512 },
      { name:       "Pungent", votes:  31, proportion: 0.1512195122 },
      { name:         "Skunk", votes:  26, proportion: 0.1268292683 },
      { name:  "Spicy/Herbal", votes:  23, proportion: 0.1121951220 },
      { name:          "Pine", votes:  22, proportion: 0.1073170732 },
    ]
  },

  "purple-urkle": {
    name:   "Purple Urkle",
    source: "storage_system",
    flavors: [
      { name:         "Grape", votes: 259, proportion: 0.2729188620 },
      { name:         "Berry", votes: 218, proportion: 0.2297154900 },
      { name:         "Sweet", votes: 191, proportion: 0.2012644889 },
      { name:         "Earthy", votes: 133, proportion: 0.1401475237 },
      { name:         "Skunk", votes:  75, proportion: 0.0790305585 },
      { name:       "Flowery", votes:  73, proportion: 0.0769230769 },
    ]
  },

};

/**
 * Look up the flavor ratios for a strain by its ID (slug).
 * Returns the flavors array sorted by proportion descending,
 * or an empty array if the strain is not in the model.
 *
 * @param {string} strainId - e.g. "max_ac", "og-kush", "mimosa"
 * @returns {{ name: string, votes: number, proportion: number }[]}
 */
export function getFlavorRatios(strainId) {
  if (!strainId) return [];
  return strainFlavorRatios[strainId]?.flavors ?? [];
}

/**
 * Check whether the model has real (non-placeholder) flavor data for a strain.
 * @param {string} strainId
 * @returns {boolean}
 */
export function hasRealFlavorData(strainId) {
  const entry = strainFlavorRatios[strainId];
  if (!entry) return false;
  return entry.source !== "public_flavors_equal";
}
